import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import {
  getEquipmentInfoRequest,
  saveEquipmentInfoRequest,
  getEquipmentInfoSuccess,
  resetSaveSuccess,
} from './info-actions';
import { blockNavigation } from '../../../common/navigation/containers/navigation-actions';
import Info from '../components/info';

const mapStateToProps = (state) => {
  const activeServiceCenter = state.navigation.navigationSelf.serviceCenterId;
  return {
    data: state.equipment.info.data,
    organisation: state.equipment.info.organisation,
    types: state.equipment.info.types,
    isLoading: state.equipment.info.isLoading,
    error: state.equipment.info.error,
    isSaving: state.equipment.info.isSaving,
    saveSuccess: state.equipment.info.saveSuccess,
    lock: state.equipment.info.lock,
    lockingErrorType: state.equipment.info.lockingErrorType,
    partners: state.equipment.info.partners,
    userStatuses: state.equipment.info.userStatuses,
    partnerTypes: state.referenceData.data[`${activeServiceCenter}_equipment_partnerTypes`],
    taskLists: state.equipment.info.taskLists,
    visitTypes: state.equipment.info.visitTypes,
    lockingErrors: state.equipment.info.lockingErrors,
  };
};

const mapDispatchToProps = {
  getEquipmentInfoRequest,
  saveEquipmentInfoRequest,
  resetSaveSuccess,
  getEquipmentInfoSuccess,
  blockNavigation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Info));
